var _effectorFileName = "/src/shared/components/card-custom/card-custom.tsx";
import { AnimatePresence, motion } from 'framer-motion';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { cn } from '@/shared/lib/cn';
import { GradientBg } from '../animation/gradient-background';
import { TextGradient } from '../text-gradient';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
interface CardCustomProps {
  isCardDataSentSuccessfully?: boolean;
  withGradient?: boolean;
  withTransparentBg?: boolean;
  children: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  cardClassName?: string;
}
export const CardCustom = (props: CardCustomProps) => {
  const {
    isCardDataSentSuccessfully,
    children,
    title,
    description,
    className,
    cardClassName,
    withGradient = true,
    withTransparentBg = true
  } = props;
  return <div className={cn('relative items-center justify-end overflow-visible 2xl:justify-center', className)}>
      <Card className={cn('flex h-full items-center justify-center', {
      'pt-6': !title,
      'bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60': withTransparentBg
    }, cardClassName)}>
        <AnimatePresence mode="wait">
          {!isCardDataSentSuccessfully && <motion.div key="form" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="w-full">
              {(title || description) && <CardHeader>
                  {title && <CardTitle>{title}</CardTitle>}
                  {description && <CardDescription>{description}</CardDescription>}
                </CardHeader>}
              <CardContent>{children}</CardContent>
            </motion.div>}

          {isCardDataSentSuccessfully && <motion.div key="success" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} className="flex h-full min-h-80 min-w-[280px] flex-col items-center justify-center md:min-w-[400px]">
              <CheckMarkIcon className="mb-4 h-12 w-12 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal" />

              <div className="text-center">
                <TextGradient text="Заявка отправлена!" className="mb-1 header-h1" />
                <p className="text-muted-foreground">Скоро мы вам напишем</p>
              </div>
            </motion.div>}
        </AnimatePresence>
      </Card>

      {withGradient && <GradientBg className="sm:var(--radial-size,100px) hidden sm:block" type="circle" origin="center" size={300} />}
    </div>;
};